<template>
  <div class="register">
    <el-form
      class="register-form"
      :model="registerForm"
      :rules="rules"
      :inline="true"
      label-width="80px"
      ref="registerForm">
      <el-form-item
        label="手机号:"
        prop="phone">
        <el-input
          class="input-primary"
          v-model="registerForm.phone"
          @input="changePhone"
          placeholder="请输入手机号"></el-input>
      </el-form-item>

      <el-form-item
        label="验证码:"
        prop="validateNo"
        class="ver-code">
        <el-input
          class="input-primary"
          v-only-number
          type="text"
          maxlength="6"
          :autocomplete="Math.random().toString(36).substr(2)"
          v-model="registerForm.validateNo"
          placeholder="请输入验证码"></el-input>
        <el-button
          class="validatenum-btn"
          type="primary"
          size="small"
          :disabled="disabledVailBtn"
          @click="getVerCode">
          {{ vercodeText }}
        </el-button>
      </el-form-item>

      <el-form-item
        label="密码:"
        prop="password">
        <el-input class="hidden-input"></el-input>
        <el-input
          class="input-primary"
          show-password
          v-model="registerForm.password"
          type="password"
          placeholder="请输入密码"></el-input>
      </el-form-item>

      <el-form-item
        label="确认密码:"
        prop="confirmPassword">
        <el-input
          class="input-primary"
          show-password
          v-model="registerForm.confirmPassword"
          type="password"
          placeholder="请再次输入密码"></el-input>
      </el-form-item>

      <el-form-item
        label="企业类型:"
        prop="enterpriseType">
        <el-select
          class="primary-select"
          v-model="registerForm.enterpriseType"
          placeholder="请选择企业类型"
          popper-class="primary-select-outer"
          :popper-append-to-body="true">
          <el-option
            v-for="item in enterpriseType"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        label="所在省份:"
        prop="province">
        <el-select
          class="primary-select"
          v-model="registerForm.province"
          placeholder="请选择所在省份"
          popper-class="primary-select-outer"
          :popper-append-to-body="true">
          <el-option
            v-for="(item, index) in localsProvince"
            :key="index"
            :label="item"
            :value="item" />
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button
          class="primary-btn register-btn"
          type="primary"
          size="small"
          @click="register">
          注册
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { enterpriseType, localsProvince, rules } from './index'
import { encryptPassword } from '@/utils/generalMethods'
import { sendValidateNoService } from '@/service/interface'
import { merge } from 'lodash-es'
import { passwordRules } from '@/utils/formValidateRules'
import { registerService } from '@/service/interface'
export default {
  data() {
    const validConfirmPassword = (rule, value, callback) => {
      if (value === this.registerForm.password) {
        callback()
      } else {
        return callback(new Error('两次输入密码不一致'))
      }
    }
    return {
      rules: merge(rules, {
        confirmPassword: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: validConfirmPassword, trigger: 'blur' },
          {
            pattern: passwordRules.pattern,
            message: passwordRules.message,
            trigger: 'blur'
          }
        ]
      }), // 合并规则
      disabledVailBtn: true,
      localsProvince,
      enterpriseType,
      registerForm: {
        phone: '',
        validateNo: '',
        password: '',
        confirmPassword: '',
        enterpriseType: '',
        province: ''
      },
      countdown: 0
    }
  },
  computed: {
    vercodeText() {
      return this.countdown > 0 ? `${this.countdown}秒后重试` : '发送验证码'
    }
  },
  watch: {
    countdown(nv) {
      if (nv > 0) {
        this.disabledVailBtn = true
      } else {
        this.changePhone()
      }
    }
  },

  methods: {
    async changePhone() {
      this.disabledVailBtn =
        !!(await this.validatePhone()) || this.countdown > 0
    },
    startCountdown() {
      this.countdown = 60
      const timer = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) {
          clearInterval(timer)
        }
      }, 1000)
    },
    async getVerCode() {
      const isPhoneValid = await this.validatePhone()
      if (isPhoneValid) {
        return // 验证失败直接返回
      }
      if (this.countdown > 0) return
      const isValid = await this.sendVerCode()
      const {
        data: { isSuccess, errMsg }
      } = isValid
      if (!isSuccess) {
        this.$message.error(errMsg)
        return
      }
      this.startCountdown()
    },
    validatePhone() {
      return new Promise(resolve => {
        this.$refs.registerForm.validateField('phone', (valid, msg) => {
          resolve(valid) // 返回验证结果（true/false）
        })
      })
    },
    register() {
      this.$refs.registerForm.validate(bool => {
        if (!bool) {
          return
        }
        const params = {
          phone: this.registerForm.phone,
          password: encryptPassword(this.registerForm.password),
          confirmPassword: encryptPassword(this.registerForm.password),
          validateNo: this.registerForm.validateNo,
          enterpriseType: this.registerForm.enterpriseType,
          province: this.registerForm.province
        }
        registerService(params).then(res => {
          if (res.status === 200) {
            let data = res.data
            if (data.isSuccess) {
              this.$message.success('注册成功')
              this.resetFields()
              this.$emit('backToHome')
            } else {
              this.$message.error(data.errMsg)
            }
          }
        })
      })
    },

    resetFields() {
      this.$refs.registerForm?.resetFields()
      this.countdown = 0
    },

    sendVerCode() {
      const params = {
        phone: this.registerForm.phone,
        validateType: 'Register'
      }
      return sendValidateNoService(params)
    }
  },
  mounted() {
    this.resetFields()
  }
}
</script>

<style scoped lang="less">
@import '@/assets/css/publishSearch.less';
.register {
  height: calc(100% - 104px);
  overflow-y: auto;

  &::-webkit-scrollbar {
    display: none;
  }
  .register-form {
    width: 100%;
    .hidden-input {
      height: 0;
      width: 0;
      :deep(.el-input__inner) {
        height: 0;
        border: none;
      }
    }
    :deep(.el-form-item) {
      display: flex;
      .el-form-item__label {
        color: var(--login-panel-input-label-color);
        white-space: nowrap;
      }
      .el-form-item__content {
        flex: 1;

        .primary-select,
        .input-primary {
          .el-input__inner {
            color: var(--login-input-text-color);
            background-color: var(--login-panel-input-bgColor);
            border-color: var(--login-panel-input-border-color);
          }
        }

        .el-select {
          width: 100%;
        }
      }
    }
    .ver-code {
      display: flex;

      :deep(.el-form-item__content) {
        display: flex;

        .validatenum-btn {
          margin-left: 16px;
          padding-left: 18px;
          padding-right: 18px;
          border-color: var(--validatenum-btn-border-color);
          border-radius: 8px;
          color: var(--validatenum-btn-color);
          background: var(--validatenum-btn-bg-color);
          font-size: 14px;

          &.is-disabled {
            color: var(--validatenum-btn-diabled-color);
            background-color: var(--validatenum-btn-diabled-bg-color);

            &:hover {
              color: var(--validatenum-btn-diabled-color);
              background-color: var(--validatenum-btn-diabled-bg-color);
            }
          }
          &:hover {
            background: var(--validatenum-btn-hover-bg-color);
            color: var(--validatenum-btn-hover-color);
          }
        }
      }
    }

    .register-btn {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 42px;
      border-radius: 8px;
    }
  }
}
</style>
